import { FC, memo, PropsWithChildren } from 'react'
import { DrawerHead } from './drawer-head'
import { SnackBar } from '../snack-bar'
import { DynamicModal } from '../../modal/dynamic'
import { DashboardInnerMock } from '@app/components/containers/dashboard-inner-mock'
import { Toaster } from '@app/@/components/ui/toaster'

const DrawerWMock: FC<
  PropsWithChildren<{
    emailConfirmationVisible?: boolean
    sendConfirmEmail?(): void
    demo?: boolean
  }>
> = ({ children, emailConfirmationVisible, demo }) => {
  return (
    <>
      <DrawerHead />
      <main id='main-content' className='flex fixed w-full h-full'>
        <DashboardInnerMock demo={demo}>{children}</DashboardInnerMock>
        <SnackBar adjustPlacement={emailConfirmationVisible} topLevel />
        <Toaster />
        <DynamicModal />
      </main>
    </>
  )
}

export const DashboardDrawerMock = memo(DrawerWMock)
